<template> 
    <div>
      <base-header class="pb-6">
        <b-row align-v="center" class="py-4">
          <b-col lg="6" cols="7">
            <h6 class="h2 text-white d-inline-block mb-0">Financial Proposal Report</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </b-col>
          <b-col cols="6" class="text-right">
            <base-button type="primary" icon size="sm" @click="close()">
              <span class="btn-inner--text">Back / Close</span>
            </base-button>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <financial-proposal-report-log-table></financial-proposal-report-log-table>
      </b-container>
    </div>
  </template>
  <script>
    import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
    import FinancialProposalReportLogTable from "@/views/FinancialProposal/CustomerFinancialProposalFolder/FinancialProposalReportLogTable";
  
    export default {
      components: {
        FinancialProposalReportLogTable,
        RouteBreadCrumb,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
      },
      data() {
        return {
        };
      },
      created() {
      },
      methods: {
        close() {
          if(this.$route.params.token)
          {
            // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
            window.history.back();
            window.close();
          }
          else
          {
            this.$router.back();
          }
        },
      }
    };
  </script>
  